import i18n from '@/plugins/i18n';

export default {
  getNameFromUserObject(u) {
    const isDebug = process.env.NODE_ENV === 'dev';
    if (!u) return 'NO User Object provided';
    let name;
    if (u.name) {
      //name attribute shows it is a group
      if (!u.users) {
        console.debug('group object has no users', JSON.stringify(u, null, 2));
      }
      name = `${i18n.t('group')} "${u.name}"`;
      // name = `${i18n.t('group')} "${u.name}" (${u.users.length} ${i18n.t('members')})`;// do not display member count as the count is not consistent with the item list
    } else if (u.firstname && u.lastname) {
      name = `${u.firstname} ${u.lastname}`;
    } else if (u.firstname) {
      name = `${u.firstname}`;
    } else if (u.lastname) {
      name = `${u.lastname}`;
    } else if (u.username) {
      name = `${u.username}`;
    } else {
      name = `${u.name}`;
      // name = `${u.name} ${u.name ? '(' + u.users.length + ' Mitglieder)' : ''}`; // do not display member count as the count is not consistent with the item list
    }

    return isDebug ? name + ` ID${u.id}` : name;
  },
  /**
   * Find the first item in the array that meets the predicate (starting at the last item)
   * @param {*} array
   * @param {*} predicate
   * @returns
   */
  findReverse(array, predicate) {
    for (let i = array.length - 1; i >= 0; --i) {
      const x = array[i];
      if (predicate(x)) {
        return x;
      }
    }
  },
  lastMsgText(msg) {
    if (msg?.text) return msg.text;
    if (msg?.type === 'image') return `Bild gesandt`;
    return '';
  },
  /**
   * True if a message where the current user is the receiver, is not read yet
   * @param message
   * @param userId
   * @returns {boolean}
   */
  isUnread(message, userId) {
    userId = Number(userId);
    return message.userIdFk === userId && message.senderIdFk !== userId && !message.dateread;
  },
  // used to count unread
  isNotRead(message, userId) {
    if (message?.isGroup) {
      return message.senderIdFk !== userId && !message.dateread;
    }
    // return message.senderIdFk !== userId && !message.dateread;
    return message.userIdFk === userId && message.senderIdFk !== userId && !message.dateread;
  },
  /**
   * Filter users and groups that have NO messages yet
   * @param skipCurrentUser
   * @param search
   * @param userId
   * @param messagesByGroupId
   * @param messagesByUserId
   * @param groupById
   * @param users
   * @param userById
   * @param groups
   * @returns {*}
   */
  filteredReceivers({ skipCurrentUser, search, userId, messagesByGroupId, messagesByUserId, groupById, users, userById, groups }) {
    console.debug('groups', groups);
    console.time('messaging:filterAndSortUsersAndGroups');
    let filteredUsers;
    let filteredGroups;

    // Filter by search text
    if (!search) {
      filteredUsers = users;
      filteredGroups = groups;
    } else {
      let lowerCasedSearch = search.toLowerCase();

      filteredUsers = users.filter((u) => {
        let searchName = `${this.getNameFromUserObject(u)} ${u.id}`.toLowerCase();
        return searchName.includes(lowerCasedSearch);
      });

      filteredGroups = groups.filter((g) => g.name.toLowerCase().includes(lowerCasedSearch));
    }

    // construct the objects for group chats
    filteredGroups = filteredGroups
      .map((g) => {
        let messages = messagesByGroupId[g.id] || [];

        // find the last message in this chat
        let group = groupById[g.id];
        let groupName = this.getNameFromUserObject(group);

        return { messages, groupId: g.id, name: groupName };
      })
      .filter((i) => i.messages.length === 0 && i.name);

    // construct the objects for direct messages (user to user)
    filteredUsers = filteredUsers
      .map((u) => {
        // compile the display name
        let messages = messagesByUserId[u.id] || [];
        let name = this.getNameFromUserObject(u);

        // find the last message in this chat
        return {
          messages,
          receiverId: u.id,
          senderId: userId,
          userId: u.id,
          firstname: u.firstname,
          name,
          can_receive_messages: u.can_receive_messages,
        };
      })
      .filter((i) => i.messages.length === 0 && i.name && i.id !== userId);

    if (skipCurrentUser) {
      filteredUsers = filteredUsers.filter((u) => u.userId !== userId);
    }
    let filteredUsersAndGroups = filteredUsers.concat(filteredGroups);

    filteredUsersAndGroups = filteredUsersAndGroups.sort((u1, u2) => {
      return this.sortReceivers(u1, u2);
    });
    //filteredUsersAndGroups = filteredUsersAndGroups.slice(0, 100); // max 100 items
    console.timeEnd('messaging:filterAndSortUsersAndGroups');
    return filteredUsersAndGroups;
  },

  /**
   * Filter users and groups that have messages, that is there is an existing conversation
   * @param skipCurrentUser
   * @param search
   * @param userId
   * @param messagesByGroupId
   * @param messagesByUserId
   * @param messagesByUserIdUnreadCount
   * @param messagesByGroupIdUnreadCount
   * @param groupById
   * @param users
   * @param userById
   * @param groups
   * @returns {*}
   */
  filterAndSortUsersAndGroups({
    skipCurrentUser,
    search,
    userId,
    messagesByGroupId,
    messagesByUserId,
    messagesByUserIdUnreadCount,
    messagesByGroupIdUnreadCount,
    groupById,
    users,
    userById,
    groups,
  }) {
    console.time('messaging:filterAndSortUsersAndGroups');
    let filteredUsers;
    let filteredGroups;
    const usersMap = users.reduce((acc, item) => {
      acc[`${item.id}`] = item;

      return acc;
    }, {});

    // Filter by search text
    if (!search) {
      filteredUsers = users;
      filteredGroups = groups;
    } else {
      let lowerCasedSearch = search.toLowerCase();

      filteredUsers = users.filter((u) => {
        let searchName = `${this.getNameFromUserObject(u)} ${u.id}`.toLowerCase();
        return searchName.includes(lowerCasedSearch);
      });

      filteredGroups = groups.filter((g) => g.name.toLowerCase().includes(lowerCasedSearch));
    }

    // construct the objects for group chats
    filteredGroups = filteredGroups
      .map((g) => {
        let messages = messagesByGroupId[g.id] || [];
        let unreadMessagesCount = messagesByGroupIdUnreadCount[g.id];
        let lastIndex = messages ? messages.length - 1 : null;

        // find the last message in this chat
        let lastMsgText = '';
        let senderName;
        let lastMsgDate;
        let group = groupById[g.id];
        let groupName = this.getNameFromUserObject(group);
        let lastMsg;
        if (messages && lastIndex >= 0) {
          let msg = messages[lastIndex];

          let sender = userById[msg.senderIdFk];
          senderName = this.getNameFromUserObject(sender);

          let msgOriginator = msg.senderIdFk === userId ? i18n.t('You') : senderName.substring(0, 15);
          lastMsg = this.findReverse(messages, (msg) => msg.type === 'text' || msg.type === 'image');

          lastMsgText = `${msgOriginator}: ${this.lastMsgText(lastMsg)}`;
          lastMsgDate = lastMsg?.datecreated ? Date.parse(lastMsg?.datecreated) : '';
        }
        return {
          messages,
          unreadMessagesCount,
          groupId: g.id,
          name: groupName,
          lastMsg,
          lastMessage: lastMsgText,
          lastMsgDate,
        };
      })
      .filter((i) => i.messages.length > 0 && i.name);

    // construct the objects for direct messages (user to user)
    filteredUsers = filteredUsers
      .map((u) => {
        // compile the display name
        let name = this.getNameFromUserObject(u);

        // find the last message in this chat
        let messages = messagesByUserId[u.id] || [];
        let unreadMessagesCount = messagesByUserIdUnreadCount[u.id];
        // console.debug("Filter users and groups that have messages, that is there is an existing conversation", u.id, "count=", unreadMessagesCount)
        let lastMsgText = '';
        let lastMsgDate;
        let lastMsg;
        if (messages && messages.length > 0) {
          let msg = messages[messages.length - 1];
          let msgOriginator = msg.receiverIdFk == u.id ? i18n.t('You') : u.firstname ? u.firstname : name.substring(0, 15);

          lastMsg = this.findReverse(messages, (msg) => msg.type === 'text' || msg.type === 'image');
          lastMsgText = `${msgOriginator}: ${this.lastMsgText(lastMsg)}`;
          lastMsgDate = lastMsg?.datecreated ? Date.parse(lastMsg?.datecreated) : '';
        }

        return {
          online: u.online,
          messages,
          unreadMessagesCount,
          receiverId: u.id,
          senderId: userId,
          userId: u.id,
          firstname: u.firstname,
          name,
          lastMsg,
          lastMessage: lastMsgText,
          lastMsgDate,
          can_receive_messages: usersMap[`${u.id}`] ? usersMap[`${u.id}`].can_receive_messages : 0,
        };
      })
      .filter((i) => i.messages.length > 0 && i.name && i.id !== userId);

    if (skipCurrentUser) {
      filteredUsers = filteredUsers.filter((u) => u.userId !== userId);
    }
    let filteredUsersAndGroups = filteredUsers.concat(filteredGroups);

    // sort order: unreadCount,lastMessage available, user bevore groups, alphabetical sort
    filteredUsersAndGroups = filteredUsersAndGroups.sort((u1, u2) => {
      return this.sortReceivers(u1, u2);
    });
    //filteredUsersAndGroups = filteredUsersAndGroups.slice(0, 100); // max 100 items
    console.timeEnd('messaging:filterAndSortUsersAndGroups');
    return filteredUsersAndGroups;
  },
  sortReceivers(u1, u2) {
    if (u1.lastMsgDate && u2.lastMsgDate) {
      return u2.lastMsgDate - u1.lastMsgDate;
    }
    if (u1.unreadMessagesCount > 0 || (u2.unreadMessagesCount > 0 && u1.unreadMessagesCount !== u2.unreadMessagesCount))
      return u2.unreadMessagesCount - u1.unreadMessagesCount;

    if (u1.lastMsgDate && !u2.lastMsgDate) {
      return -1;
    }
    if (u2.lastMsgDate && !u1.lastMsgDate) {
      return 1;
    }

    // no messages, sort users asc, then groups asc
    if (u1.userId && u2.groupId) return -1;
    if (u1.userId && u2.userId) return u1.name.localeCompare(u2.name);
    if (u1.groupId && u2.userId) return -1;
    if (u1.groupId && u2.groupId) return u1.name.localeCompare(u2.name);
    return 0;
  },

  /**
   * Calculates isSender,isReceiver and additional messageType
   *
   * Message type is one of GROUP_SENDER, GROUP_RECEIVER,SENDER,RECEIVER
   */
  computeMessageType(message, userId) {
    let type = {};
    if (message.isBroadcast) {
      type.isSender = false;
      type.isReceiver = true;
      type.messageType = 'BROADCAST_RECEIVER';
    } else if (message?.isGroup) {
      if (userId === message.senderIdFk) {
        type.isSender = true;
        type.isReceiver = false;
        type.messageType = 'GROUP_SENDER';
      } else {
        type.isSender = false;
        type.isReceiver = true;
        type.messageType = 'GROUP_RECEIVER';
      }
    } else {
      if (userId === message.senderIdFk) {
        type.isSender = true;
        type.isReceiver = false;
        type.messageType = 'SENDER';
      } else {
        //if (userId === message.receiverIdFk) {
        type.isSender = false;
        type.isReceiver = true;
        type.messageType = 'RECEIVER';
      }
    }
    return type;
  },
};
